import {useAuthService} from '~/composables/useAuthService';
import {USER_FORM_PROMPT_EXITS} from '~/composables/useUserFormPrompts';
import {mfaWallDestination} from '~/utils/mfa';

/**
 * Two-step sign-in (MFA_PLAN.md): an account the API says must verify is
 * held at the verify step (or the set-up step when nothing is enrolled)
 * until this session has proved it. Runs before the form and user tag walls
 * (alphabetical): a super admin proves who they are before anything else.
 * THE BLOCKING IS THE ROUTE, as with the other walls; the API refuses the
 * calls anyway (403 mfa_required), this just puts the person on the right page.
 */
export default defineNuxtRouteMiddleware((to) => {
  const {isAuthenticated, user} = useAuthService();
  if (!isAuthenticated.value) return;
  // The log-out and legal exits of the other walls apply; the profile page does
  // NOT: a super admin's profile is full of account data.
  const exits = USER_FORM_PROMPT_EXITS.filter((e) => e !== '/your-profile' && e !== '/admin/super');
  const destination = mfaWallDestination(to.fullPath, user.value, exits);
  if (destination) return navigateTo(destination);
});
